/**
 * Owner: Haselton Baker Risk Group, LLC
 * Copyright All Rights Reserved
 */
// @flow
import type { Element } from 'react';

import React from 'react';
import { Link } from 'react-router-dom';
import { Button, Card, CardBody, FormGroup, FormText, Label, Row, Col } from 'reactstrap';
import { COMPONENT_POPULATION_METHOD } from '@hbrisk/sp3-risk-model-support/models/app/attributes/names/index.js';
import BackButton from '#components/pages/Models/Model/sections/support/buttons/BackButton.jsx';
import NextButton from '#components/pages/Models/Model/sections/support/buttons/NextButton.jsx';
import Tip from '#components/support/tooltips/Tip/index.jsx';
import {
  Field,
  FormGroup as ModelFormGroup,
} from '#components/pages/Models/Model/support/form/index.js';
import ModelComponentsTable from './ModelComponentsTable/index.js';

type Props = {|
  fieldsByName: Object,
  heading: string,
  form: string,
  onBack: Function,
  onNext: Function,
  canAddComponent: boolean,
  showCustomWarning: boolean,
|};

const MainView = (props: Props): Element<'div'> => {
  const { fieldsByName, form, heading, onBack, onNext, canAddComponent, showCustomWarning } = props;
  return (
    <div>
      <h2>{heading}</h2>
      <FormGroup tag="fieldset">
        <legend>Component Selection Method</legend>
        <ModelFormGroup form={form} fields={[COMPONENT_POPULATION_METHOD]}>
          <Row>
            <Col lg="11">
              <Label htmlFor={COMPONENT_POPULATION_METHOD}>
                {fieldsByName[COMPONENT_POPULATION_METHOD].label}
              </Label>{' '}
              <Tip tipId={COMPONENT_POPULATION_METHOD} />
              <Field field={fieldsByName[COMPONENT_POPULATION_METHOD]} excludeLabel />
            </Col>
          </Row>
        </ModelFormGroup>
        {showCustomWarning && (
          <FormText id="userDefinedWarning" color="muted">
            * Building Component inventory will not automatically update to reflect other model
            changes. <Tip tipId="componentPopulationMethodCustomWarning" />
          </FormText>
        )}
      </FormGroup>
      <Card>
        <CardBody>
          <Row>
            <Col>
              <div className="float-right">
                {canAddComponent && (
                  <Button id="addComponent" className="pr-0" to="add" color="link" tag={Link}>
                    + Add Component
                  </Button>
                )}
              </div>
            </Col>
          </Row>
          <Row>
            <Col>
              <ModelComponentsTable form={form} />
            </Col>
          </Row>
        </CardBody>
      </Card>
      <div>
        <BackButton onClick={onBack} />
        <NextButton onClick={onNext} />
      </div>
    </div>
  );
};

export default MainView;
